import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInitialState } from './types';
import { IUserData } from '@common/types/types';

const SLICE_NAME = 'USER_SLICE';

const initialState: IInitialState = {
  siteUUID:'',
  loading: false,
  error: '',
  acceptEulaLoding: false ,
  acceptEulaError :'' ,
  acceptEulaSuccess : false,
  checkAcceptEulaLoding: false,
  checkAcceptEulaError: '',
  checkAcceptEulaSuccess: true,
  data: {
    token: '',
    userId: '',
    email: '',
    tenantId: '',
    isAuthorize: false,
    isEmailNotificationsEnabled: null,
    isNewsletterNotificationsEnabled: null,
    isWebsiteOwner: null,
    isWidgetUser: null,
    firstName: '',
    lastName: '',
    isSuperAdmin: null,
    hasOrganizations: false,
   organizationsId:"",
    role:"",
    name:"",
    // profile_status:"client",
    userSelectedOrganization : "",
    company : null,
    company_id : "",
    websiteCount:0
  },
  copiedLinkfilterByPage: ''
};

const userSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    currentFailedAction: (state, { payload: error }) => {
      state.loading = false;
      state.error = error;
    },
    currentAction: (state) => {
      state.loading = true;
    },
    currentSucceededAction: (state, { payload: { data } }: PayloadAction<{ data: IUserData }>) => {
      state.data.email = data.email;
      state.data.tenantId = data.tenantId;
      state.data.userId = data.userId;
      state.data.isEmailNotificationsEnabled = data.isEmailNotificationsEnabled;
      state.data.isNewsletterNotificationsEnabled = data.isNewsletterNotificationsEnabled;
      state.data.isWebsiteOwner = data.isWebsiteOwner;
      state.data.isWidgetUser = data.isWidgetUser;
      state.data.firstName = data.firstName;
      state.data.lastName = data.lastName;
      state.data.hasOrganizations = data.hasOrganizations;
      state.data.organizationsId = data.organizationsId;
      state.data.role = data.role;
      state.data.name =  data.name;
      // state.data.profile_status = data.profile_status; 
      state.data.userSelectedOrganization = data.userSelectedOrganization;
      state.data.userPermission = data.userPermission;
      // state.data.isUser = data.isUser;
      state.data.company_id = data.company_id;
      state.data.company_name = data.company_name;
      state.data.websiteCount= data.websiteCount;
      state.loading = false;
    },
    updateCurrent: (state, { payload }) => {
      state.loading = true;
    },
    updateCurrentSuccess: (state, { payload: { data } }: PayloadAction<{ data: IUserData }>) => {
      state.loading = false;
      state.data.isEmailNotificationsEnabled = data.isEmailNotificationsEnabled;
      state.data.isNewsletterNotificationsEnabled = data.isNewsletterNotificationsEnabled;
      state.data.isWebsiteOwner = data.isWebsiteOwner;
      state.data.isWidgetUser = data.isWidgetUser;
      state.data.firstName = data.firstName;
      state.data.lastName = data.lastName;
    },
    setIsSuperAdminAction: (state, { payload: isSuperAdmin }) => {
      state.data.isSuperAdmin = isSuperAdmin;
    },
    updateCurrentError: (state, { payload: error }) => {
      state.loading = false;
      state.error = error;
    },
    setUserIdAction: (state, { payload: idToken }) => {
      state.data.token = idToken;
    },
    setIsAuthorizeAction: (state, { payload: isAuthorize }) => {
      state.data.isAuthorize = isAuthorize;
    },
    logoutUserAction: (state) => {
      state.loading = true;
    },
    logoutUserFailedAction: (state, { payload: error }) => {
      state.loading = false;
      state.error = error;
    },
    deleteCurrent: (state, { payload }) => {
      state.loading = true;
    },
    deleteCurrentError: (state, { payload: error }) => {
      state.loading = false;
    },
    deleteCurrentSuccess: (state, { payload }) => {
      state.loading = false;
    },

    updateCurrentUserOrganizationInfo: (state, { payload }) => {
      state.loading = true;
    },
    updateCurrentUserOrganizationInfoError: (state, { payload: error }) => {
      state.loading = false;
    },
    updateCurrentUserOrganizationInfoSuccess:  (state, { payload: { data } }: PayloadAction<{ data: IUserData }>) => {
      state.loading = false;
      state.data.isEmailNotificationsEnabled = data.isEmailNotificationsEnabled;
      state.data.isNewsletterNotificationsEnabled = data.isNewsletterNotificationsEnabled;
      state.data.isWebsiteOwner = data.isWebsiteOwner;
      state.data.isWidgetUser = data.isWidgetUser;
      state.data.firstName = data.firstName;
      state.data.lastName = data.lastName;
      state.data.hasOrganizations = data.hasOrganizations;
      state.data.organizationsId = data.organizationsId;
      state.data.role = data.role;
      state.data.name = data.name;
      // state.data.profile_status = data.profile_status;
    },
    updateUserNotificationError: (state) => {
      state.loading = false;
      state.error = "error";
    },

    updateUserNotification: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },

    updateUserNotificationSuccess: (state, { payload }) => {
      state.loading = false;
      state.data.isEmailNotificationsEnabled = payload;
    },

    acceptEulaError: (state) => {
      state.acceptEulaLoding = false;
      state.acceptEulaError = "error";
    },

    acceptEula: (state, { payload }) => {
      state.acceptEulaLoding = true;
      state.acceptEulaError = '';
    },

    acceptEulaSuccess: (state, { payload }) => {
      state.acceptEulaLoding = false;
      state.acceptEulaSuccess = true;
    },

    checkAcceptedEulaError: (state) => {
      state.checkAcceptEulaLoding = false;
      state.checkAcceptEulaError = "error";
    },

    checkAcceptedEula: (state, { payload }) => {
      state.checkAcceptEulaLoding = true;
      state.checkAcceptEulaError = '';
    },

    checkAcceptedEulaSuccess: (state, { payload }) => {
      state.checkAcceptEulaLoding = false;
      state.checkAcceptEulaSuccess = payload;
    },   
    setCopiedLinkfilterByPage: (state, { payload }) => {
      state.copiedLinkfilterByPage = payload;
    },  
    FireCopiedLinkfilterByPage: (state, { payload }) => {
      // state.copiedLinkfilterByPage = payload;
    },  
    FirePutsiteUUID: (state, { payload }) => {
      // state.copiedLinkfilterByPage = payload;
    },  
    putsiteUUID: (state, { payload }) => {
      state.siteUUID = payload;
    },  

  },
});

export default userSlice;